import {Space} from "antd";
import {SessionOfferingFormProps} from "../session/types";
import {BundleSessionSettingsFormFields} from "./settings";
import {
  CreateBundleOfferingFormGroups,
  EditBundleOfferingFormGroups,
} from "../../accordion/data";
import {applyOfferingFormFeatureFlags} from "../../accordion/apply-feature-flags-to-form-groups";
import {OfferingFormAccordionItem} from "../../accordion/accordion-item";
import {BundleSessionPricingFormFields} from "./pricing";
import {SessionAvailabilityScheduleSummary} from "../session/availability/schedule-summary";
import {SessionRedirectAfterPurchaseFormFields} from "../session/redirect-after-purchase";

export function CreateBundleSessionOfferingForm({
  formType,
  isGeneralInformationError,
  isLocationError,
  isPricingError,
  isSettingsError,
  isSessionPeriodError,
  isAvailabilityError,
}: SessionOfferingFormProps & {
  isSessionPeriodError?: boolean;
}) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {applyOfferingFormFeatureFlags(CreateBundleOfferingFormGroups).map((fg, index) => {
        if (fg.title === "General information") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isGeneralInformationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Session period") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSessionPeriodError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Pricing") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isPricingError}
            >
              <BundleSessionPricingFormFields />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Availability") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isAvailabilityError}
              summary={<SessionAvailabilityScheduleSummary />}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Location") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isLocationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Email automation") {
          return (
            <OfferingFormAccordionItem key={fg.title} index={index} title={fg.title}>
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Redirect after purchase") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <SessionRedirectAfterPurchaseFormFields />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Settings") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <BundleSessionSettingsFormFields formType={formType} />
            </OfferingFormAccordionItem>
          );
        } else return null;
      })}
    </Space>
  );
}

export function EditBundleSessionOfferingForm({
  formType,
  isGeneralInformationError,
  isLocationError,
  isPricingError,
  isSettingsError,
  isSessionPeriodError,
  isCoverImagesError,
  isAvailabilityError,
}: SessionOfferingFormProps & {
  isSessionPeriodError?: boolean;
}) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {applyOfferingFormFeatureFlags(EditBundleOfferingFormGroups).map((fg, index) => {
        if (fg.title === "General information") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isGeneralInformationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Session period") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSessionPeriodError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Cover image") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isCoverImagesError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Pricing") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isPricingError}
            >
              <BundleSessionPricingFormFields />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Availability") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isAvailabilityError}
              summary={<SessionAvailabilityScheduleSummary />}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Location") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isLocationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Email automation") {
          return (
            <OfferingFormAccordionItem key={fg.title} index={index} title={fg.title}>
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Redirect after purchase") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <SessionRedirectAfterPurchaseFormFields />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Settings") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <BundleSessionSettingsFormFields formType={formType} />
            </OfferingFormAccordionItem>
          );
        } else return null;
      })}
    </Space>
  );
}
